export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "歪歪漫画多久更新一次？",
    a: "我们每日 10:00 与 18:00 各更新一批作品，热门连载固定每日更新，专题与同人剧场每周上新。你可以通过站内「最新更新」栏目第一时间追更，也可以开启收藏后在新版本上架时收到提醒。",
  },
  {
    q: "漫画可以免费阅读吗？",
    a: "歪歪漫画面向所有读者免费开放全站作品，无需下载客户端即可在电脑、平板和手机上直接阅读。我们希望通过轻松的内容把快乐传递给更多人，所以坚持免费、无门槛。",
  },
  {
    q: "如何快速找到想看的作品？",
    a: "你既可以在顶部搜索框输入作品名、作者或关键词进行精准检索，也可以通过首页的六大分类——恶搞、反转、神展开、脑洞、魔性和爆笑——逐层筛选。分类页支持按最新、热度与评分排序。",
  },
  {
    q: "可以给喜欢的作品点赞或收藏吗？",
    a: "当然可以。每部作品详情页都提供收藏和评分入口，收藏后会进入你的「我的收藏」列表，方便随时续读；你的点赞也会直接反映在热门榜单的排名上。",
  },
  {
    q: "作品封面和内容预览是原创的吗？",
    a: "站内作品均由签约作者原创或经授权引入，封面与分镜统一采用高辨识度的 pop-art 扁平漫画风格，方便读者一眼认出。我们坚持原创优先，抵制抄袭与低质搬运。",
  },
  {
    q: "我想投稿自己的漫画，怎么联系？",
    a: "欢迎所有热爱漫画的创作者！你可以通过「联系我们」页面提交作品简介与联系方式，我们通常在 3 个工作日内回复。优秀的投稿有机会登上首页推荐，并获得签约与创作扶持。",
  },
];